import axios from 'axios'
import moment from 'moment-timezone'


if (process.env.REACT_APP_HOST == 'NETLIFY') {
    var axios_init = {
        baseURL: 'https://webapp.dev.alacrityps.com/api/v1',
        headers: {'Access-Control-Allow-Origin': '*', 'crossDomain': true}
    }
} else {
    var axios_init = {
        baseURL: `${process.env.PUBLIC_URL}/api/v1`
    }
}

const instance = axios.create(axios_init)

function formatQueryString (params) {
  return Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
}

export function resetPatientDevice (deviceId) {
  return instance.get(`/patients/${deviceId}/reset`).then(response => response.data.patient)
}

export function getActivationCode () {
  return instance.post(`/patients`).then(response => response.data.patient.activationCode)
}

export function getPatients (options) {
  return instance.get(`/patients?${formatQueryString(options)}`).then(response => response.data.patients)
}

export function getPatient (id) {
  return instance.get(`/patients/${id}`).then(response => response.data.patient)
}

export function updatePatient (id, data) {
  return instance.put(`/patients/${id}`, data)
    .then(response => response.data.patient)
}

export function archivePatient (id) {
  return instance.put(`/patients/${id}`, { status: 'Inactive' })
}

export function reactivatePatient (id) {
  return instance.put(`/patients/${id}`, { status: 'Active' })
}

export function createNote (patientId, data) {
  return instance.post(`/patients/${patientId}/notes`, data).then(response => response.data.notes)
}

export function getPatientSnapshot (patientId, dates) {
  if (!dates) { dates = [new Date()] } // default to today if no date is provided
  const formattedDateString = dates.map(date => `date=${moment(date).format('YYYY-MM-DD')}`).join('&')
  return instance.get(`/patients/${patientId}/snapshots?${formattedDateString}&tz=US/Pacific`).then(response => response.data.day_summaries)
}

export function getPatientTrends (id) {
  return instance.get(`/patients/${id}/trends`)
}

export function getPatientNotes (id) {
  return instance.get(`/patients/${id}/notes`).then(response => response.data.notes)
}

export function getPatientTreatments (id) {
  return instance.get(`/patients/${id}/treatments`).then(response => response.data)
}

export function createPatientTreatment (id, data) {
  return instance.post(`/patients/${id}/treatments`, data).then(response => response.data.treatment)
}

export function getChronicConditions () {
  return instance.get('/chronic-conditions').then(response => response.data.chronic_conditions)
}

export function getCancerTypes () {
  return instance.get('/cancer-types').then(response => response.data.cancer_types)
}

export function getCancerStages () {
  return instance.get('/cancer-stages').then(response => response.data.cancer_stages)
}

export function getCancerTreatments () {
  return instance.get('/drugs').then(response => response.data.drugs)
}

export function getEthnicities () {
  return instance.get('/ethnicities').then(response => response.data.ethnicities)
}

export function getLoggedInUser () {
  return instance.get('/user').then(response => response.data)
}



// WEBPACK FOOTER //
// ./src/api.js